import { Dispatch } from "react-redux";
import * as moment from 'moment';
import { AuthActionCreators, IApplicationState } from "..";
import { IListItem, IPhlebotRequest } from "../../models/index";
import { IBaseResponse } from '@nkr/models/index';
import { IOrderRequest } from "@nkr/models/order-request";

export interface IPhlebotRequestResponse {
    data: {
        success: boolean,
        results: IPhlebotRequest[]
    }
}

export interface IOrderListRequestResponse {
    data: {
        success: boolean,
        results: IOrderRequest[]
    }
}

export interface IOrderLookupResponse {
    data: {
        success: boolean,
        results: {
            kitTypes: IListItem[],
            shipVendors: IListItem[],
            orderStatuses: IListItem[]
        }
    }
}

export interface IPhlebotLookupResponse {
    data: {
        success: boolean,
        results: {
            phlebotKitTypes: IListItem[],
            stateList: IListItem[]
        }
    }
}

export const PhlebotActionCreators = {

    getKitRequestListRange: (startDate: Date, endDate: Date, centerId: number, dateType: number) => (dispatch: Dispatch<IApplicationState>): Promise<IOrderListRequestResponse> => {
        let url = `${__API__}/admin/orders`;

        if (centerId > 0) {
            url = `${__API__}/orders/kit-requests`;
        }
        
        let options = {
            url: url,
            data: {
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate).format("YYYY-MM-DD"),
                centerId: centerId,
                dateType
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IOrderListRequestResponse) => {
            return Promise.resolve(response);
        });
    },

    getKitLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IOrderLookupResponse> => {
        let url = `${__API__}/admin/orders/lookup`

        if (centerId > 0) {
            url = `${__API__}/orders/kit-lookup`;
        }   

        var options = {
            url
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getRequestListRange: (centerId: number, startDate: Date, endDate: Date, dateType: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IPhlebotRequestResponse> => {
        let url = `${__API__}/exam-one/requests`;
        
        let options = {
            url: url,
            data: {
                centerId: centerId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate).format("YYYY-MM-DD"),
                dateType: dateType
            }
        };
        
        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IPhlebotLookupResponse> => {
        var options = {
            url: `${__API__}/exam-one/lookup`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    updateRequest: (request: IPhlebotRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let url = `${__API__}/exam-one/request`;
        
        let options = {
            url: url,
            data: request
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    updateStatusToSent: (requestId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let url = `${__API__}/exam-one/request/${requestId}/status/0`; //0 = SENT
        
        let options = {
            url: url
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    reorderRequest: (requestId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/exam-one/reorder/${requestId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
};
